<!-- 学籍异动列表 -->
<template>
    <div class="el-stuStatusChangeApply">
        <el-row class="page_content">
            <h1 class="head_title">学籍异动</h1>
            <!-- <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="是否填写">
                    <el-select v-model="form.teaEvaluateStudentStatus" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <el-option label="已填写" value="1"></el-option>
                        <el-option label="未填写" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否填写">

                </el-form-item>
            </el-form> -->
            <div style="margin-bottom: 10px;">
                <el-button type="primary" icon="el-icon-plus" @click="addStuStatusChange">申请学籍异动</el-button>
            </div>
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column prop="afterState" header-align="center" align="center" width="180" label="异动类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.afterState == '1'">在籍</span>
                        <span v-if="scope.row.afterState == '1_2'">转专业</span>
                        <span v-if="scope.row.afterState == '1_3'">转函授站</span>
                        <span v-if="scope.row.afterState == '1_4'">转班级</span>
                        <span v-if="scope.row.afterState == '1_5'">复学</span>
                        <span v-if="scope.row.afterState == '1_6'">留级</span>
                        <span v-if="scope.row.afterState == '2'">休学</span>
                        <span v-if="scope.row.afterState == '3'">未报到</span>
                        <span v-if="scope.row.afterState == '4'">主动退学</span>
                        <span v-if="scope.row.afterState == '5'">勒令退学</span>
                        <span v-if="scope.row.afterState == '6'">取消学籍</span>
                        <span v-if="scope.row.afterState == '7'">已毕业</span>
                    </template>
                </el-table-column>
                <el-table-column prop="corSchoolName" header-align="center" align="center" width="180" label="异动后函授站">
                    <template slot-scope="scope">{{scope.row.corSchoolName || '-'}}</template>
                </el-table-column>
                <el-table-column prop="professionalName" header-align="center" align="center" width="180" label="异动后专业">
                    <template slot-scope="scope">{{scope.row.professionalName || '-'}}</template>
                </el-table-column>
                <el-table-column prop="schoolClassName" header-align="center" align="center" width="180" label="异动后班级">
                    <template slot-scope="scope">{{scope.row.schoolClassName || '-'}}</template>
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="center" width="180" label="申请时间">
                </el-table-column>
                <el-table-column prop="auditStatus" header-align="center" align="center" width="180" label="审核状态">
                    <template slot-scope="scope">
                        <!-- 1已审核 2未审核 3不通过 -->
                        <template v-if="scope.row.auditStatus == 1"><span style="color: #409EFF;">审核通过</span></template>
                        <template v-if="scope.row.auditStatus == 2"><span style="color: rgb(147 144 144);">未审核</span></template>
                        <template v-if="scope.row.auditStatus == 3"><span style="color: red;">不通过</span></template>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" header-align="center" align="center" label="审核结果备注">
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: center;position: absolute;bottom: 0;width: 96%;margin-bottom: 20px;">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1" :page-size="limit" :hide-on-single-page="true"
                    layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-row>

        <!-- 申请学籍异动对话框 -->
        <el-dialog title="申请学籍异动" :visible.sync="dialogVisible" @close="closeDialog" width="800px">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="异动类型" prop="afterState">
                    <!-- 申请之后：学籍状态(1在籍 1_2转专业 1_3转函授站 1_4转班级 1_5复学 1_6留级 2休学 3未报到 4主动退学 5勒令退学 6取消学籍 7已毕业) -->
                    <el-select v-model="ruleForm.afterState" placeholder="请选择异动类型" @change="changeAfterState">
                        <!-- <el-option label="在籍" value="1"></el-option> -->
                        <el-option label="转专业" value="1_2"></el-option>
                        <el-option label="转函授站" value="1_3"></el-option>
                        <el-option label="转班级" value="1_4"></el-option>
                        <!-- <el-option label="复学" value="1_5"></el-option> -->
                        <el-option label="留级" value="1_6"></el-option>
                        <el-option label="休学" value="2"></el-option>
                        <el-option label="未报到" value="3"></el-option>
                        <el-option label="主动退学" value="4"></el-option>
                        <el-option label="勒令退学" value="5"></el-option>
                        <!-- <el-option label="取消学籍" value="6"></el-option>
                        <el-option label="已毕业" value="7"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item label="转专业" v-if="ruleForm.afterState == '1_2'" prop="professionalId">
                    <el-select v-model="ruleForm.professionalId" placeholder="请选择专业" >
                        <el-option v-for="(item, index) in professionalList" :key="index+'professionalList'" :label="item.professionalName" :value="item.professionalId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转函授站" v-if="ruleForm.afterState == '1_3'" prop="corSchoolId">
                    <el-select v-model="ruleForm.corSchoolId" placeholder="请选择函授站" >
                        <el-option v-for="(item, index) in correspondenceSchoolList" :key="index+'correspondenceSchoolList'" :label="item.corSchoolName" :value="item.corSchoolId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转班级" v-if="ruleForm.afterState == '1_4'" prop="schoolClassId">
                    <el-select v-model="ruleForm.schoolClassId" placeholder="请选择班级" >
                        <el-option v-for="(item, index) in schoolClassList" :key="index+'schoolClassList'" :label="item.schoolClassName" :value="item.schoolClassId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitInfo" :loading="submitBut">立即申请</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: "StuStatusChangeApply",
        data() {
            return {
                form: {
                    teaEvaluateStudentStatus: ""
                },
                ruleForm: {
                    afterState: '',
                    professionalId: '',
                    corSchoolId: '',
                    schoolClassId: "",
                },
                rules: {
                    afterState: [{
                        required: true,
                        message: '请选择异动类型',
                        trigger: 'change'
                    }],
                    professionalId: [{
                        required: true,
                        message: '请选择专业',
                        trigger: 'change'
                    }],
                    corSchoolId: [{
                        required: true,
                        message: '请选择函授站',
                        trigger: 'change'
                    }],
                    schoolClassId: [{
                        required: true,
                        message: '请选择班级',
                        trigger: 'change'
                    }],
                },
                tableData: [],
                submitBut: false,
                currentPage1: 1,
                total: 0,
                limit: 6,
                page: 1,
                dialogVisible: false,
                professionalList:[], //专业List
                correspondenceSchoolList:[], //函授站List
                schoolClassList:[],//班级List
                studentInfo:{},
            };
        },
        created() {
            this.getSurveyList();
            this.getPersonalInfo();
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.limit = val;
                this.getSurveyList();
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.page = val;
                this.getSurveyList();
            },
            getSurveyList() { //获取List
                let param = this.form;
                param.limit = this.limit;
                param.page = this.page;
                this.$store.dispatch("user/getStudentChangeRecordList", this.form).then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.tableData = ret.data;
                        this.total = ret.count;
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            getPersonalInfo(){
                this.$store.dispatch("user/getPersonalInfo").then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.studentInfo = ret.data || {};
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            changeAfterState(e){ //异动类型变更
                if(e == '1_2'){ //转专业
                    if(this.professionalList.length > 0){
                        return;
                    }
                    this.$store.dispatch("user/getProfessionalValues",{professionalStatus:1,grade:this.studentInfo.grade}).then((ret) => {
                        if (ret.code === 0 || ret.code === '0') {
                            this.professionalList = ret.data || [];
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }else if(e == '1_3'){ //转函授站
                    if(this.correspondenceSchoolList.length > 0){
                        return;
                    }
                    this.$store.dispatch("user/getCorrespondenceSchoolValues",{corSchoolStatus:1,grade:this.studentInfo.grade}).then((ret) => {
                        if (ret.code === 0 || ret.code === '0') {
                            this.correspondenceSchoolList = ret.data || [];
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }else if(e == '1_4'){ //转班级
                    if(this.schoolClassList.length > 0){
                        return;
                    }
                    this.$store.dispatch("user/getSchoolClassValues",{
                            schoolClassStatus:1,
                            grade:this.studentInfo.grade,
                            professionalId:this.studentInfo.professionalId,
                            corSchoolId:this.studentInfo.corSchoolId,
                        }).then((ret) => {
                        if (ret.code === 0 || ret.code === '0') {
                            this.schoolClassList = ret.data || [];
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }else{
                    this.ruleForm.professionalId = "";
                    this.ruleForm.corSchoolId = "";
                    this.ruleForm.schoolClassId = "";
                }
            },
            selectScore(v) {
                this.getSurveyList();
            },
            addStuStatusChange() {
                this.dialogVisible = true;
            },
            closeDialog(){ //关闭对话框时执行
                this.$refs['ruleForm'].resetFields();
            },
            submitInfo() { //提交数据
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确定提交，提交后将无法进行修改?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                            this.$store.dispatch("user/applyStatusChange", this.ruleForm).then((ret) => {
                                loading.close();
                                if (ret.code === 0 || ret.code === '0') {
                                    this.$message.success("保存成功！");
                                    this.getSurveyList();
                                    this.dialogVisible = false;
                                } else {
                                    this.$message({
                                        message: ret.msg,
                                        type: 'warning'
                                    });
                                }
                            }).catch((error) => {
                                // this.$message({
                                //     message: "接口请求失败！",
                                //     type: 'warning'
                                // });
                                loading.close();
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '取消提交'
                            });
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    };
</script>
<style lang="less">
    @import '../../styles/base.less';

    .el-stuStatusChangeApply {
        .wd {
            color: @red;
        }

        .el-dialog__body {
            border-top: 1px solid #ebeef5;
        }

        .el-descriptions-item__container {
            font-size: 17px;
        }

        .el-descriptions-item__label {
            white-space: nowrap;
            width: 140px;
            text-align: right;
        }

        .el-descriptions-item__content {
            max-height: 200px;
            overflow: auto;
        }

        .teacherEvaluateInfoClass {
            .el-table .el-table__cell {
                padding: 5px 0;
            }
        }

        .teaEvaluateDesc {
            p {
                margin: 5px 0;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/statusChange/stuStatusChangeApply.vue